import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import {
  firstStepConfig,
  RegistrationStepsEnum,
  stepsConfigs,
} from './constant'

const domain = createDomain('features.documentBaseRegistration.step')

export const Gate = createGate()

export const goToNextStep = domain.createEvent()
export const goToBackStep = domain.createEvent()

export const goToConfirmStep = domain.createEvent()
export const goToSuccessStep = domain.createEvent()
export const goToErrorStep = domain.createEvent()

export const goToFirstStep = domain.createEvent()

export const $currentStep = domain
  .createStore<string>(firstStepConfig)
  .on(goToNextStep, (state) => {
    const foundIndex = stepsConfigs.findIndex((step) => state === step)
    return stepsConfigs[foundIndex + 1]
  })
  .on(goToBackStep, (state) => {
    const foundIndex = stepsConfigs.findIndex((step) => state === step)
    return stepsConfigs[foundIndex - 1]
  })
  .on(goToConfirmStep, () => {
    const foundIndex = stepsConfigs.findIndex(
      (step) => step === RegistrationStepsEnum.CONFIRM_CODE_STEP,
    )
    return stepsConfigs[foundIndex]
  })
  .on(goToSuccessStep, () => {
    const foundIndex = stepsConfigs.findIndex(
      (step) => step === RegistrationStepsEnum.SUCCESS_STEP,
    )
    return stepsConfigs[foundIndex]
  })
  .on(goToErrorStep, () => {
    const foundIndex = stepsConfigs.findIndex(
      (step) => step === RegistrationStepsEnum.ERROR_STEP,
    )
    return stepsConfigs[foundIndex]
  })
  .on(goToFirstStep, () => firstStepConfig)

sample({
  clock: Gate.close,
  target: goToFirstStep,
})

export const $currentStepFlags = $currentStep.map((step) => ({
  isPassportStep: step === RegistrationStepsEnum.PASSPORT_STEP,
  isDriverLicenseStep: step === RegistrationStepsEnum.DRIVER_LICENSE_STEP,
  isAdditionalDataStep: step === RegistrationStepsEnum.ADDITIONAL_DATA,
  isCorrectionStep: step === RegistrationStepsEnum.CORRECTION_STEP,
  isConfirmCodeStep: step === RegistrationStepsEnum.CONFIRM_CODE_STEP,
  isSuccessStep: step === RegistrationStepsEnum.SUCCESS_STEP,
  isErrorStep: step === RegistrationStepsEnum.ERROR_STEP,
}))
